"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Code: function() {
        return Code;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const Code = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M14.2169 2.02377C14.7561 2.14358 15.096 2.67776 14.9762 3.21689L10.9762 21.2169C10.8564 21.756 10.3222 22.096 9.78307 21.9761C9.24394 21.8563 8.90401 21.3222 9.02381 20.783L13.0238 2.78303C13.1436 2.2439 13.6778 1.90396 14.2169 2.02377ZM6.70711 7.29285C7.09763 7.68338 7.09763 8.31654 6.70711 8.70707L3.41421 12L6.70711 15.2929C7.09763 15.6834 7.09763 16.3165 6.70711 16.7071C6.31658 17.0976 5.68342 17.0976 5.29289 16.7071L1.29289 12.7071C0.902369 12.3165 0.902369 11.6834 1.29289 11.2929L5.29289 7.29285C5.68342 6.90233 6.31658 6.90233 6.70711 7.29285ZM17.2929 7.29285C17.6834 6.90233 18.3166 6.90233 18.7071 7.29285L22.7071 11.2929C23.0976 11.6834 23.0976 12.3165 22.7071 12.7071L18.7071 16.7071C18.3166 17.0976 17.6834 17.0976 17.2929 16.7071C16.9024 16.3165 16.9024 15.6834 17.2929 15.2929L20.5858 12L17.2929 8.70707C16.9024 8.31654 16.9024 7.68338 17.2929 7.29285Z",
        fill: "currentColor"
    })
}), "Code");
const _default = Code;
